<script lang="ts">
  import { onMount } from 'svelte';
  
  interface Props {
    checked?: boolean;
    disabled?: boolean;
    children?: import("svelte").Snippet;
    onClick: () => void;
    onChange: () => void;
    name?: string;
    value?: string;
  }

  let { 
    checked = false, 
    disabled = false, 
    children, 
    onChange, 
    onClick, 
    name = 'product-option',
    value = ''
  }: Props = $props();
  
  let containerElement: HTMLDivElement;
  
  const handleKeyDown = (e: KeyboardEvent) => {
    // Only handle space or enter key on the container itself, not on interactive children
    if ((e.key === ' ' || e.key === 'Enter') && e.target === containerElement) {
      e.preventDefault();
      if (!checked) {
        onChange();
        onClick();
      }
    }
  };
  
  const handleContainerClick = (e: MouseEvent) => {
    // Don't trigger if the click was on an interactive element
    const target = e.target as HTMLElement;
    if (target.tagName === 'A' || target.tagName === 'BUTTON' || target.closest('a, button, [role="button"]')) {
      return;
    }
    onClick();
  };
  
  $effect(() => {
    if (containerElement && checked) {
      containerElement.focus();
    }
  });
</script>

<div
  class="transition-colors p-4 duration-200 mb-2 w-full border-2 border-opacity-50 focus-within:border-opacity-100 border-Neutral400 shadow-InputContainer {checked
    ? ' bg-Violet100 border-Violet700'
    : 'bg-Neutral110 hover:bg-Neutral200'} {disabled ? ' opacity-50 pointer-events-none' : ''}"
  role="radio"
  aria-checked={checked}
  tabindex={disabled ? -1 : 0}
  onkeydown={handleKeyDown}
  onclick={handleContainerClick}
  onchange={onChange}
  bind:this={containerElement}
>
  <label class="cursor-pointer block">
    <input 
      type="radio" 
      name={name}
      value={value}
      checked={checked} 
      class="sr-only" 
      tabindex={-1}
      onchange={onChange}
      onclick={onClick}
    />
    {@render children?.()}
  </label>
</div>
